import { create } from 'zustand'

interface UpdateRequiredState {
  /** El servidor respondió 426: esta versión de la app ya no está soportada. */
  required: boolean
  markRequired: () => void
}

/**
 * Versión mínima de la app (spec `2026-10-17-version-minima-app`): lo activa el interceptor de
 * `httpClient` al recibir `426 error.app.update.required` y lo lee `UpdateRequiredScreen`.
 * No hay forma de desactivarlo en la sesión: solo actualizar la app lo resuelve.
 */
export const useUpdateRequiredStore = create<UpdateRequiredState>((set) => ({
  required: false,
  markRequired: () => set({ required: true }),
}))
